import { fetchServices } from '../../../../api/commonApi'
import { useConnectedAppsStore } from '../../../stores/useConnectedAppsStore'

const AUDIT_LOG_SERVICE_KEYS = ['email', 'office']
const REFRESH_INTERVAL_MS = 60 * 60 * 1000

type AuditLogService = {
  key?: unknown
  is_active?: unknown
  settings?: { is_subscription_active?: unknown }
}

export const hasAuditLoggingViolation = (services: unknown): boolean => {
  if (!Array.isArray(services)) return false

  return services.some((service: AuditLogService) => {
    if (typeof service?.key !== 'string') return false
    if (!AUDIT_LOG_SERVICE_KEYS.includes(service.key)) return false

    return (
      service.is_active === true &&
      service.settings?.is_subscription_active === false
    )
  })
}

let refreshTimer: ReturnType<typeof setInterval> | null = null

const stopAuditLoggingRefreshTimer = () => {
  if (refreshTimer === null) return

  clearInterval(refreshTimer)
  refreshTimer = null
}

const refreshAuditLoggingStatus = async () => {
  try {
    const services = await fetchServices()
    syncAuditLoggingStatus(services || [])
  } catch (error) {
    console.error('Failed to refresh audit logging status:', error)
  }
}

export const syncAuditLoggingStatus = (services: unknown) => {
  const violation = hasAuditLoggingViolation(services)
  useConnectedAppsStore.getState().setAuditLoggingViolation(violation)

  if (!violation) {
    stopAuditLoggingRefreshTimer()
    return
  }

  if (refreshTimer !== null) return

  refreshTimer = setInterval(() => {
    void refreshAuditLoggingStatus()
  }, REFRESH_INTERVAL_MS)
}

export const stopAuditLoggingMonitor = stopAuditLoggingRefreshTimer
